import axios from 'axios'
import store from '@/store/index'
import router from '@/router'
import showMessage from './showMessage'
import {tokenRefresh} from '@/api/index'
axios.defaults.timeout = 100000
axios.defaults.headers.post['Content-Type'] = 'application/json'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: '100000', // 100秒请求时间超时
  paramsSerializer: (params) => {
    const arr = []
    for (const key in params) { arr.push(`${key}=${encodeURIComponent(params[key])}`) }
    return arr.join('&')
  }
})

request.interceptors.request.use(
  (config) => {
    const token = store.getters.token
    token && (config.headers['x-authorization'] = `Bearer ${token}`)
    token && (config.headers['authorization'] = `Bearer ${token}`)

    if (config.base === 'origin') {
      config.baseURL =
        process.env.NODE_ENV === 'development'
          ? '/origin'
          : process.env.VUE_APP_ORIGIN_URL
    }
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // 特殊接口处理
    if (!Object.hasOwnProperty.call(response.data, 'errorCode') &&
      (response.data.type === 'application/octet-stream' ||
        response.data.type === 'application/vnd.ms-excel')) {
      // 针对下载文件，返回数据格式
      return response
    }
    if (response.status === 200) {
      // 检查 response.data 是否包含 errorCode 属性
      if (response.data && response.data.errorCode) {
        // 检查 data.errorCode 是否等于0
        if (response.data.errorCode === 0) {
          return Promise.resolve(response)
        } else {
          // 错误信息提示
          const errorCodeMessage = {
            1001: '操作失败，输入为空',
            1002: '操作失败，无效输入',
            1003: '操作失败，名称重复',
            1004: '操作失败，用户名和密码不匹配',
            1005: '操作失败，用户不存在或未启用',
            1006: '操作失败，数据不存在',
            1007: '操作失败，组织有关联客户',
            1008: '操作失败，无效输入',
            1009: '操作失败，角色代码重复',
            1010: '操作失败，角色代码是系统自己的',
            1011: '旧密码错误',
            1012: '新旧密码不能一样',
            1013: '管理员和指定用户不在同一租户中',
            1014: '没有权限'
          }
          showMessage(errorCodeMessage[response.data.errorCode] || `操作失败,${response.data.errorMsg}`)
          return Promise.reject(response)
        }
      } else {
        return Promise.resolve(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  (error) => {
    if (error.response.status) {
      console.log('🚀 ~ error:', error)
      let refreshToken = sessionStorage.getItem('refreshToken')
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // showMessage('登录过期，请重新登录')
          if(refreshToken){
            tokenRefresh({
              refreshToken
            }).then(async(req)=>{
              await store.dispatch('user/setToken', req.data.token)
              sessionStorage.setItem('refreshToken',req.data.refreshToken)
            })
          }else{
            store.dispatch('user/logout')
            setTimeout(() => {
              router.replace({
                path: '/login'
              })
            }, 1000)
          }                
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          if(refreshToken){
            tokenRefresh({
              refreshToken
            }).then(async(req)=>{
              await store.dispatch('user/setToken', req.data.token)
              sessionStorage.setItem('refreshToken',req.data.refreshToken)
            })
          }else{
            store.dispatch('user/logout')
            setTimeout(() => {
              router.replace({
                path: '/login'
              })
            }, 1000)
          }      
          break
        // 404请求不存在
        case 404:
          showMessage('网络请求不存在')
          break
        // 其他错误，直接抛出错误提示
        default:
          if (error.response.data.message.includes('already exists')) {
            showMessage('操作失败, 账户已存在')
          } else if (error.response.data.message.includes('already present')) {
            showMessage('操作失败, 用户名已存在')
          } else if (error.response.data.message.includes('password')) {
            showMessage('登录失败,账号或密码错误')
          } else if (error.response.data.message.includes('no body')) {
            showMessage('登录失败,账号或密码错误')
          }else {
            showMessage(error.response.data.message)
          }
      }
      return Promise.reject(error.response)
    }
  }
)

export default request
